import type { ComponentType } from "react"
import StartStopContinueContent from "./start-stop-continue"
import FourLsContent from "./4ls"
import SailboatContent from "./sailboat"
import MadSadGladContent from "./mad-sad-glad"
import DakiContent from "./daki"
import StarfishContent from "./starfish"
import PlusDeltaContent from "./plus-delta"
import WwwContent from "./www"
import LeanCoffeeContent from "./lean-coffee"
import GroceriesContent from "./groceries"
import PrevailContent from "./prevail"
import GearListContent from "./gear-list"
import HouseholdChoresContent from "./household-chores"

/**
 * Long-form article content per template detail page. Keyed by template.id
 * from src/models/template.ts. Parity is enforced by index.test.ts — adding
 * a template to TEMPLATES without a corresponding entry here will break
 * that test.
 */
export const TEMPLATE_CONTENT: Record<string, ComponentType> = {
  "start-stop-continue": StartStopContinueContent,
  "4ls": FourLsContent,
  "sailboat": SailboatContent,
  "mad-sad-glad": MadSadGladContent,
  "daki": DakiContent,
  "starfish": StarfishContent,
  "plus-delta": PlusDeltaContent,
  "www": WwwContent,
  "lean-coffee": LeanCoffeeContent,
  "groceries": GroceriesContent,
  "prevail": PrevailContent,
  "gear-list": GearListContent,
  "household-chores": HouseholdChoresContent,
}
